 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		90: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"02a7221","1":"18c7164","2":"d164cfb","3":"dbbb398","4":"96a36cb","5":"6ba3288","6":"9efea13","7":"4622176","8":"cf94102","9":"7e1f846","10":"33422ce","11":"5c128e6","12":"e7ce1c7","13":"e85c435","14":"d29462b","15":"2632e0b","16":"c39c926","17":"72bd68b","18":"ab1e557","19":"4b3d16f","20":"ad8ce42","21":"d9de615","22":"361d56d","23":"9a4902c","24":"9b4142c","25":"02ab412","26":"f3a3ab7","27":"351f985","28":"1961b3e","29":"6dd0ad3","30":"dc3d857","31":"3a6ee44","32":"265b200","33":"5d13f9e","34":"bc6b664","35":"c808d42","36":"2d6ca7f","37":"de8fc6a","38":"5c83727","39":"5232bcb","40":"67a4c1c","41":"5cea696","42":"2aa27a2","43":"e3295f7","44":"42bb0b8","45":"db591b3","46":"d002a41","47":"c16ce32","48":"55c3e5c","49":"66ecbc1","50":"84d266d","51":"5cdf5af","52":"316edca","53":"de30248","54":"bdbc5c3","55":"62b9b56","56":"9057b93","57":"1da2c6c","58":"0d7cbbf","59":"d7faf0b","60":"c7af4c7","61":"6032747","62":"c2b8eee","63":"982d1ae","64":"7affa76","65":"261afe3","66":"86bb7a3","67":"a656e53","68":"4301255","69":"8e7885a","70":"0f28652","71":"195ef13","72":"a9060be","73":"46e49ef","74":"b1846f0","75":"34ee46b","76":"f3f4268","77":"23a37f6","78":"aa92e1e","79":"957de4b","80":"c63f19a","81":"278b847","82":"58ff308","83":"3e4f246","84":"6a434be","85":"7afb4f7","86":"c5de684","87":"37feff8","88":"fa249b3","89":"8f91480","92":"87affb4","93":"0c8d498","94":"feed896","95":"02d6f03","96":"8875c0f","97":"404c6a2","98":"0eb8ee2","99":"e7691e2","100":"01026bd","101":"08609b7","102":"51003af","103":"cf12392","104":"86648f1","105":"68a4974","106":"4c9943e","107":"104e8bf","108":"9199d51","109":"1b4b5f3","110":"1b07419","111":"44932d0","112":"c4cfc5c","113":"9d64e75","114":"54a5d07","115":"8c213e7","116":"9b070b8","117":"f7b5ef2","118":"d435f67","119":"5206ba3","120":"a44aaf4","121":"e908632","122":"3c87d97","123":"0170da9","124":"76fbd5d","125":"3bdba84","126":"ae14539","127":"bfbcb2b","128":"e6db89b","129":"f1ae4bf","130":"64d23d8","131":"99f05dd","132":"2262a7b","133":"17cbe45","134":"ec02de2","135":"c6afaa4","136":"3e2fdbe","137":"b5f0640","138":"9198b09","139":"6cd71ea","140":"0c9666d","141":"a37f6a5","142":"374bb70","143":"58b1630","144":"d3d96e5","145":"68c4bc0","146":"e78508c","147":"d81fb17","148":"87e9a32","149":"2148bcb","150":"e60d630","151":"2c88e13","152":"16d7fdb","153":"a4a6edb","154":"981a995","155":"6c5f177","156":"fb44a1b","157":"1c62fff","158":"194f630","159":"1150058","160":"74ce043","161":"f75f2d7","162":"895e396","163":"f0f3830","164":"76e6172","165":"e816b02","166":"1ea0f76","167":"010c651","168":"668c353","169":"c1ab063","170":"47d9ce9","171":"5207624","172":"105dc24","173":"8e7925e","174":"2d1cef0","175":"c350465","176":"da17701","177":"c7b730c","178":"4d9d60c","179":"00926b2","180":"eea20bb","181":"044cf0d","182":"06be11b","183":"da240ef","184":"b004522","185":"4eb1cd8","186":"dc126fc","187":"965b59a","188":"8064f45","189":"f5399eb","190":"c5c9b4f","191":"d650067","192":"49fafdc","193":"e6a5c8b","194":"f53ba3c","195":"3f4e89a","196":"ed2ec07","197":"cceb880","198":"dff12e9","199":"2604761","200":"c0e61a5","201":"c3e23d5","202":"e2a3bd9","203":"b3f25d4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/cms/veranstaltungen/roundnetturrnier_2025/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([165,91]);
 	// run deferred modules when ready
 	return checkDeferredModules();
